import { Suspense } from "react";
import { LinearProgress, Portal } from "@mui/material";

import { useMapPoint } from "hooks/mapHooks";
import { useActiveSelection } from "hooks/selectionHooks";

import { LayerProperties } from "types";
import { MapWMSLayer } from "./MapWMSLayer";
import { SelectedLayerGeometryLoad } from "./SelectedLayerGeometryLoad";

interface Props {
  config: string;
  layerProperties: LayerProperties[];
  overlayContainer: Element;
}

export function SelectedWMSLayers(props: Props) {
  const { config, layerProperties, overlayContainer } = props;
  const { data: selection } = useActiveSelection(config, layerProperties);
  const [point] = useMapPoint();

  return render();

  function render() {
    if (!selection) return null;

    // sort indicators by order, lower is higher on the map, therefore reverse the order
    const sortedIndicators = selection.indicators.sort(
      (a, b) => b.order - a.order
    );

    return (
      <>
        {sortedIndicators.map((indicator, i) => (
          <Suspense
            key={`wmslayer-${indicator.indicatorId}`}
            fallback={
              <Portal container={overlayContainer}>
                <LinearProgress />
              </Portal>
            }
          >
            <MapWMSLayer
              key={`wmslayer-${indicator.indicatorId}`}
              config={config}
              layerProperties={layerProperties}
              selection={indicator}
              // start at default tilePane index: 200 https://leafletjs.com/reference.html#map-mappane
              // plus 10 to always stay on top of the BaseLayer
              zIndex={200 + 10 + i}
            />
            {point && (
              <SelectedLayerGeometryLoad
                key={`geometery-${point.lat}-${point.lng}`}
                config={config}
                selection={indicator}
                point={point}
                layerProperties={layerProperties}
              />
            )}
          </Suspense>
        ))}
      </>
    );
  }
}
